










import { Component, Vue } from 'vue-property-decorator';
import * as UnavailabilityApi from '@/api/unavailabilityApi';
import Unavailability from '@/models/unavailability/unavailability';
import UnavailabilityCalendar from '@/components/unavailability/UnavailabilityCalendar.vue';
import Nullable from '@/types/nullable';

@Component({
  components: {
    UnavailabilityCalendar
  }
})
export default class MyUnavailability extends Vue {
  private loading: boolean = false;
  private unavailability: Unavailability[] = [];
  private errorMessage: Nullable<string> = null;

  async init(){
    this.loading = true;

    try {
      this.unavailability = await UnavailabilityApi.getMyUnavailability();
    } catch(err){
      this.errorMessage = err;
    }

    if(!this.unavailability){
      this.unavailability = [];
    }  

    this.loading = false;
  }

  hideError(){
    this.errorMessage = null;
  }

  created(){
    this.init();
  }
}
